module.exports = __webpack_public_path__ + "static/189798458.150a83bd.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/components/c-footer/img/189798458.png
// module id = 740
// module chunks = 2